import React, { useState } from "react";
import * as Mui from "@mui/material";
import { themes } from "services/constants";
import { Payments, Redeem, ShoppingBasket } from "@mui/icons-material";
import { AttendanceDetails } from "./AttendanceDetails";
import { PaymentDetails } from "./PaymentDetails";
import { DoubleArrow } from "@mui/icons-material";
import { PayslipDetails } from "./PayslipDetails";
import { usePayrollCycleRun } from "../../PayrollCycleRunContext";
import { UserDetailsRow } from "components/CustomComponents/UserDetailsRow";

export const EditAndSidePeek = ({
  onClose,
  recallEmployee,
  setRecallEmployee,
}) => {
  const [buttonNotify, setButtonNotify] = useState("Attendance");
  const { attendanceData } = usePayrollCycleRun();

  const renderTabContent = () => {
    switch (buttonNotify) {
      case "Attendance":
        return (
          <AttendanceDetails
            setRecallEmployee={setRecallEmployee}
          />
        );
      case "Payment":
        return (
          <PaymentDetails
            setRecallEmployee={setRecallEmployee}
          />
        );

      case "Payslip":
        return <PayslipDetails />;

      default:
        alert("They have no option to view");
    }
  };

  const payrollData = [
    {
      id: 1,
      icon: ShoppingBasket,
      label: "Gross Salary",
      value: attendanceData?.gross_pay ?? 0,
      bgColor: "#c411110d",
      iconBgColor: "#bd09091a",
      iconBorderColor: "#D71515",
      iconColor: "#D71515",
    },
    {
      id: 2,
      icon: Payments,
      label: "Net Salary",
      value: attendanceData?.net_salary ?? attendanceData?.net_salary ?? 0,
      bgColor: "#3c73e70d",
      iconBgColor: "#3c73e71a",
      iconBorderColor: "#3C73E7",
      iconColor: "#3C73E7",
    },
    {
      id: 3,
      icon: Redeem,
      label: "Net Pay",
      value: attendanceData?.net_pay ?? 0,
      bgColor: "#09bd710d",
      iconBgColor: "#09bd711a",
      iconBorderColor: "#09BD71",
      iconColor: "#09BD71",
    },
  ];

  return (
    <Mui.Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Mui.Paper elevation={0}>
        <Mui.Box>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1,
            }}
          >
            <Mui.Box sx={{ ml: 1 }}>
              <Mui.IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": {
                    backgroundColor: themes?.whiteColor,
                  },
                }}
              >
                <DoubleArrow />
              </Mui.IconButton>
            </Mui.Box>
          </Mui.Box>
        </Mui.Box>
      </Mui.Paper>

      <Mui.Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
        <Mui.Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
          }}
        >
          <Mui.Box>
            <UserDetailsRow
              userDetails={{
                image_url: attendanceData?.image_url,
                employee_id: attendanceData?.employee_id,
                user_name: attendanceData?.employee_name,
                department_name: attendanceData?.department,
                designation: attendanceData?.designation,
              }}
            />
          </Mui.Box>

          <Mui.Box sx={{ flexGrow: 1, overflow: "auto", p: 2, pt: 0 }}>
            <Mui.Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
              }}
            >
              {payrollData.map((item) => {
                const IconComponent = item.icon;
                return (
                  <Mui.Card
                    key={item.id}
                    sx={{
                      width: 220,
                      height: 123,
                      bgcolor: item.bgColor,
                      borderRadius: 1,
                      boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                      border: `0.5px solid ${item.iconBorderColor}`,
                    }}
                  >
                    <Mui.CardContent
                      sx={{
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <Mui.Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 1,
                        }}
                      >
                        <Mui.Box
                          sx={{
                            width: 35,
                            height: 35,
                            bgcolor: item.iconBgColor,
                            border: `0.5px solid ${item.iconBorderColor}`,
                            borderRadius: 1,
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.25)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 1.5,
                          }}
                        >
                          <IconComponent
                            width={16}
                            height={16}
                            style={{ color: item.iconColor, padding: 2 }}
                          />
                        </Mui.Box>
                        <Mui.Typography
                          variant="body1"
                          sx={{
                            fontWeight: 600,
                            mt: 0.8,
                          }}
                        >
                          {item.label}
                        </Mui.Typography>
                      </Mui.Box>
                      <Mui.Typography
                        variant="h6"
                        sx={{
                          fontWeight: 700,
                          color: "#32325D",
                        }}
                      >
                        {item.value}
                      </Mui.Typography>
                    </Mui.CardContent>
                  </Mui.Card>
                );
              })}
            </Mui.Box>
          </Mui.Box>

          <Mui.Grid container>
            <Mui.Grid item xs={12}>
              <Mui.Grid sx={{ display: "flex", justifyContent: "center" }}>
                <Mui.ButtonGroup
                  fullWidth
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    "& .MuiButton-root": {
                      borderRadius: 0,
                    },
                    "& .MuiButton-root:first-of-type": {},
                    "& .MuiButton-root:last-of-type": {},
                  }}
                >
                  <Mui.Button
                    variant={
                      buttonNotify === "Attendance" ? "contained" : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Attendance");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Attendance"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Attendance"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Attendance"
                          ? "white"
                          : themes.headLine,
                    }}
                  >
                    Attendance
                  </Mui.Button>
                  <Mui.Button
                    variant={
                      buttonNotify === "Payment" ? "contained" : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Payment");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Payment"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Payment"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Payment" ? "white" : themes.headLine,
                    }}
                  >
                    Earning Summary
                  </Mui.Button>

                  <Mui.Button
                    variant={
                      buttonNotify === "Payslip" ? "contained" : "outlined"
                    }
                    onClick={() => {
                      setButtonNotify("Payslip");
                    }}
                    sx={{
                      background:
                        buttonNotify === "Payslip"
                          ? themes?.softMutedGreen
                          : themes.shadowBackGround,
                      textTransform: "capitalize",
                      border: "none",
                      "&:hover": {
                        border: "none",
                        background:
                          buttonNotify === "Payslip"
                            ? themes?.softMutedGreen
                            : themes.shadowBackGround,
                      },
                      color:
                        buttonNotify === "Payslip" ? "white" : themes.headLine,
                    }}
                  >
                    Payslip
                  </Mui.Button>
                </Mui.ButtonGroup>
              </Mui.Grid>
              <Mui.Grid
                container
                sx={{ paddingTop: 0.5, backgroundColor: themes.whiteColor }}
              >
                {renderTabContent()}
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Box>
      </Mui.Box>
    </Mui.Box>
  );
};
